import React, { useRef, useState } from 'react'
import { ErrorToaster, SuccessToaster } from '../../../feature-module/components/toaster/Toaster'
import InvoiceServices from '../../../services/Invoice'
import { getFileSize } from '../../../utils'
import ImageWithBasePath from '../../img/imagewithbasebath'
import { Link } from 'react-router-dom'
import { Trash2 } from 'feather-icons-react/build/IconComponents'

const InvoiceForm = ({ getData }) => {

  const fileRef = useRef();

  const [loading, setLoading] = useState(false);

  // *For Invoice File
  const [fileData, setFileData] = useState(null);

  // *For Upload File
  const handleUploadFile = (event) => {
    try {
      const file = event.target.files[0];

      if (!file) return;

      // Validate File Type
      const validExtensions = ["xls", "xlsx", "csv"];
      const fileExtension = file.name.split('.').pop().toLowerCase();

      if (!validExtensions.includes(fileExtension)) {
        ErrorToaster("Invalid file type. Please upload only .xls, xlsx or .csv file.");
        return;
      }

      const fileReader = new FileReader();
      fileReader.onload = (event) => {
        let obj = {
          file: file,
          preview: event.target.result
        }
        setFileData(obj)
      };
      fileReader.readAsDataURL(file);
    } catch (error) {
      console.log('handleUploadFile => error:', error)
    }
  };

  const handleRemoveFile = () => {
    setFileData(null)
    fileRef.current.value = null
  }

  // *For Submit Form
  const submitForm = async () => {
    setLoading(true)
    try {
      if (!fileData?.file) {
        ErrorToaster('Please upload file')
        return
      }
      const formData = new FormData();
      formData.append('file', fileData?.file);
      const { message } = await InvoiceServices.importInvoice(formData)
      SuccessToaster(message)
      const btn = document.getElementById('modalClose')
      btn.click();
      handleRemoveFile()
      getData();
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="modal fade modal-default pos-modal upload-modal" id="open-modal">
      <div className="modal-dialog modal-dialog-centered custom-modal-two">
        <div className="modal-content">
          <div className="page-wrapper-new p-0">
            <div className="content">
              <div className="modal-header border-0 custom-modal-header">
                <div className="page-title">
                  <h4>Import Invoice</h4>
                </div>
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => handleRemoveFile()}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body custom-modal-body">
                <div className="row">
                  <div className="col-lg-12">
                    <div className="input-blocks image-upload-down">
                      <label> Upload .xls / .csv File</label>
                      <div className="image-upload download">
                        <input ref={fileRef} type="file" accept='.xls, .csv' onChange={(e) => handleUploadFile(e)} />
                        <div className="image-uploads">
                          <ImageWithBasePath src="assets/img/download-img.png" alt="img" />
                          <h4>
                            Drag and drop a <span>file to upload</span>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                  {fileData?.file && (
                    <div className="col-lg-12">
                      <ul>
                        <li className="d-flex align-items-center justify-content-between">
                          <div className="d-flex align-items-center w-85">
                            <img
                              src="assets/img/icons/xls.svg"
                              alt="Folder"
                              className="me-2"
                            />
                            <div className="flex-fill">
                              <h6>
                                <Link to="#">{fileData?.file?.name}</Link>
                              </h6>
                              <span>{getFileSize(fileData?.file?.size)}</span>
                              {/* <div className="progress mt-2">
                                <div
                                  className="progress-bar bg-success"
                                  role="progressbar"
                                  style={{ width: "75%" }}
                                  aria-valuenow={75}
                                  aria-valuemin={0}
                                  aria-valuemax={100}
                                />
                              </div> */}
                            </div>
                          </div>
                          <div className="d-flex align-items-center">
                            <Link
                              to="#"
                              className="text-danger me-2 d-flex align-items-center"
                              onClick={() => handleRemoveFile()}
                            >
                              <Trash2 size="16" />
                            </Link>
                          </div>
                        </li>
                      </ul>
                    </div>
                  )}
                </div>
                <div className="modal-footer-btn">
                  <button
                    id="modalClose"
                    type="button"
                    className="btn btn-cancel me-2"
                    data-bs-dismiss="modal"
                    onClick={() => handleRemoveFile()}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-submit"
                    onClick={() => submitForm()}
                    disabled={loading}
                  >
                    {loading ? "Uploading..." : "Upload"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceForm;
